import HSwiper from './HSwiper.vue'

// 为组件提供 install 安装方法，供按需引入
HSwiper.install = function (Vue) {
    Vue.component(HSwiper.name, HSwiper)
}
  
// 默认导出组件
export default HSwiper